export const MANAGE_POSTS_PAGE = 'back_office/manage_posts';
export const POST_EDIT_PAGE = 'back_office/post_edit';
export const POST_CREATE_PAGE = 'back_office/post_create';
